module.exports = __webpack_public_path__ + "img/section4BgSvgM.524b9307.svg";